module.exports = __webpack_public_path__ + "static/img/speed-four.76df5010.jpg";